import React from 'react';
import LogoUpload from '../LogoUpload/LogoUpload';

const HeaderUpload = () => {
    return <LogoUpload type="header" />;
};

export default HeaderUpload;